import {
  GRID_OPERATORS_AT,
  GRID_OPERATORS_DE,
  GRID_OPERATORS_BOTH,
} from '../../data/gridOperators';
import type { UncontrolledComboBoxItem } from '../../common/FormFields/ComboBox/UncontrolledComboBox';
import type { ControlArea } from './controlArea';

// oxlint-disable-next-line import/prefer-default-export -- shared facility helper
export function getGridOperatorsForControlArea(
  controlArea?: ControlArea
): UncontrolledComboBoxItem[] {
  switch (controlArea) {
    case 'apg':
      return GRID_OPERATORS_AT;
    case 'tennet':
    case '50hertz':
    case 'amprion':
    case 'transnetBW':
      return GRID_OPERATORS_DE;
    default:
      return GRID_OPERATORS_BOTH;
  }
}
